module.exports = __webpack_public_path__ + "components/country-flag/static/cl-940984f7a2310f0a92df7723c3225ce1.svg";